
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCreditsByBorrowerId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"borrowerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllCreditsStatusOption"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllCreditsPagination"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllCreditsByBorrowerId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"borrowerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"borrowerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalItems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentPage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"merchantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bankName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iban"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"simulationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"borrower"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"aprc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"feesAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"penaltyPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"penaltyGracePeriod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rejectedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rejectedReason"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":700}};
    doc.loc.source = {"body":"query GetAllCreditsByBorrowerId(\n  $borrowerId: String!\n  $status: GetAllCreditsStatusOption\n  $pagination: GetAllCreditsPagination\n) {\n  getAllCreditsByBorrowerId(borrowerId: $borrowerId, status: $status, pagination: $pagination) {\n    metadata {\n      totalItems\n      currentPage\n    }\n    credits {\n      id\n      merchantId\n      bankAccount {\n        id\n        bankName\n        iban\n      }\n      simulationId\n      product\n      status\n      borrower {\n        id\n        firstname\n        lastname\n      }\n      aprc\n      amount\n      feesAmount\n      penaltyPercentage\n      penaltyGracePeriod\n      startedAt\n      endedAt\n      failedAt\n      rejectedAt\n      rejectedReason\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetAllCreditsByBorrowerId"] = oneQuery(doc, "GetAllCreditsByBorrowerId");
        
